export enum EducationLevelEnum {
  Unknown = 0,
  Primary = 1,
  MiddleSchool = 2,
  V_Mbo = 3,
  SecondaryAndPostSecondary = 4,
  Mbo_General = 5,
  Mbo_1 = 6,
  Mbo_2 = 7,
  Mbo_3 = 8,
  Mbo_4 = 9,
  Bachelor = 10,
  HboMaster = 11,
  WoBachelor = 12,
  Master = 13,
  WoPhd = 14,
}

export interface EducationModel {
  id: string;
  name: string | null;
  code: string | null;
  country: string | null;
  education_level_id: string;
  education_level: string | null;
  education_category_ids: string[] | null;
  education_categories: string[] | null;
}

export interface SchoolModel {
  id: string;
  name: string | null;
  country: string | null;
}

export interface EducationCategoryModel {
  id: string;
  name: string | null;
  educations_count: number;
  education: string[] | null;
}

export interface EducationLevelModel {
  id: string | null;
  name: string | null;
  country: string | null;
  education_level: EducationLevelEnum;
  is_basic: boolean | null;
  rank: number | null;
  delete: boolean | null;
}
